import * as types from './constants';

export function setActiveUserInfo(userInfo) {
  return { type: types.SET_ACTIVE_USER, userInfo };
}
